<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-calendar-o fa-fw"
                            placeholder="Criação"
                            :optionsList="[
                                { id: 'M', search: 'Marcação' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.tipo_data">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" :class="filtro.id_unidade_operacao ? 'text-success' : ''" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)"
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-4">
                        <az-input
                            placeholder="Todos os Procedimentos..."
                            icon="fa fa-play fa-fw"
                            type="select"
                            service="procedimentos.index"
                            optionsMode="aql"
                            optionsData="id_procedimento"
                            :optionsParm="{ agenda: true, infusao: true }"
                            v-model="filtro.id_procedimento" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="incluir()">
                                        <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                                    </button>

                                    <print-export printid="lista-pacientes" id="botao-de-imprimir" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && ( lista && lista.length )"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state 
            v-if="!lista || !lista.length" 
            :msg="!dados.paciente ? 'Nenhum paciente encontrado...' : ''" 
            icon="fa-solid fa-user-injured" />

        <div id="lista-pacientes" v-else>

            <cabecalho-generico titulo="Planejamento Infusão">
            </cabecalho-generico>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(item, index) in lista" :key="index">
                <div class="card-body py-1 px-2">
                    <div class="row">
                        <div class="col col-12 col-md-2">
                            <a href="#" class="card-link" @click.prevent="editar(item)">
                                #{{ item.id_infusao }}
                            </a>
                            <div v-if="item.created_at"> 
                                {{ $util.getFormatDate(item.created_at) }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div v-if="item.paciente">
                                <celula-dados-paciente 
                                    :hor="{ marcacao: { 
                                        plano: item.plano,
                                        paciente: item.paciente
                                    }
                                }" />
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <a href="#" @click.prevent="filtrar(item.st_titulo)" class="card-link">
                                {{ item.st_titulo }}
                            </a>
                            <div v-if="item.procedimento" class="small text-muted">{{ item.procedimento.search }}</div>
                            <div class="small" v-if="item.medico">
                                {{ item.medico.st_nome_exibicao }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-2 d-flex justify-content-between">
                            <div>
                                <template v-if="item.proxima_marcacao && item.protocolo">
                                    <div v-if="item.proxima_marcacao.in_qt_ciclo" title="Ciclo">
                                        <i class="fa-solid fa-arrows-spin fa-fw mr-1"></i>
                                        {{ item.proxima_marcacao.in_qt_ciclo }} / {{ item.protocolo.receita.in_ciclos }}
                                        <span class="badge badge-secondary mr-1" title="Duração do Ciclo">
                                            {{ item.protocolo.receita.in_duracao }}d
                                        </span>
                                    </div>
                                    <div title="Próximo Atendimento.">
                                        <i class="fas fa-calendar-alt fa-fw mr-1"></i>
                                        {{ item.proxima_marcacao 
                                            ? $util.getFormatDate(item.proxima_marcacao.dt_inicio) 
                                            : 'Não Agendada' }}

                                        <span class="badge badge-secondary" v-if="item.proxima_marcacao && item.proxima_marcacao.in_qt_dia">
                                            D{{ item.proxima_marcacao.in_qt_dia }}
                                        </span>
                                    </div>
                                </template>

                                <template v-else>
                                    <div class= "text-muted">
                                        Nenhuma marcação realizada.
                                    </div>
                                </template>
                            </div>

                            <!-- Menu de opções -->
                            <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button class="dropdown-item" @click="agendar(item)">
                                        Realizar Marcação
                                    </button>

                                    <button class="dropdown-item" @click="resumo_medicamentos(item)" v-if="item && item.id_paciente">
                                        Histórico de Medicações
                                    </button>

                                    <button class="dropdown-item" @click="log(item)">
                                        Log
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer py-1 px-2 small" v-if="item.protocolo && item.protocolo.receita && item.protocolo.receita.flat_items && item.protocolo.receita.flat_items.length">
                    <div v-for="(rmi, imx) in item.protocolo.receita.flat_items" :key="imx">
                        {{ rmi.estoque_item.search }}
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ rmi.in_quantidade }} {{ rmi.estoque_item.st_unidade_estoque }}
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ rmi.quantidades_compra }}
                    </div>
                </div>
            </div>

        </div>

        <!-- Inclusão/Edição do Paciente -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-cheio" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Infusão
                            <span class="badge badge-secondary ml-2" v-if="edicao && edicao.id_infusao">
                                #{{ edicao.id_infusao }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="!edicao">
                        <az-empty-state />
                    </div>
                    <div class="modal-body" v-else>
                        <div class="form-row mb-1" v-if="!edicao.id_infusao">
                            <div class="col col-12 col-md-6">
                                <az-periodo v-model="edicao.periodo" :sync="true" @sync="buscar_receitas()" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <div class="input-group mb-1">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fa fa-building fa-fw" :class="edicao.id_unidade_operacao ? 'text-success' : ''" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <select class="form form-control" v-model="edicao.id_unidade_operacao">
                                        <option value="">Unidades...</option>
                                        <option v-for="(und, iux) in $util.unidades_com_tags(false, true)"
                                            :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    placeholder="Profissional..."
                                    icon="fas fa-user-md fa-fw"
                                    type="select"
                                    optionsMode="aql"
                                    service="medicos.index"
                                    optionsName="medicos-cadastro"
                                    optionsData="id_pessoa"
                                    :optionsParm="{ ativos: true }"
                                    v-model="edicao.id_medico" />
                            </div>
                        </div>
                        <div class="form-row mb-3">
                            <div class="col col-12" :class="!edicao.paciente ? 'col-md-6' : ''">
                                <az-input 
                                    placeholder="Informe o nome ou CPF do paciente..."
                                    icon="fas fa-user"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="pacientes.index"
                                    optionsDisplay="search"
                                    ref="info_paciente"
                                    :edicao="!edicao.id_infusao"
                                    v-model="edicao.paciente" 
                                    :optimized_ac="true"
                                    @input="selecionarPaciente()" />
                            </div>
                            <div class="col col-12 col-md-6" v-if="!edicao.paciente">
                                <az-input
                                    icon="fa fa-search fa-fw"
                                    placeholder="Pesquisar..."
                                    v-model="edicao.search" />
                            </div>
                        </div>

                        <template v-if="lista_receitas.length || ( edicao.protocolos && edicao.protocolos.length )">

                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    <div>{{ edicao.st_titulo ? edicao.st_titulo : 'Selecione o Protocolo...'}}</div>
                                    <div v-if="edicao.procedimento" class="text-muted">{{ edicao.procedimento.search }}</div>
                                </div>
                                <div>
                                    <div>
                                        Ciclos: {{ edicao.ciclos }}
                                    </div>
                                    <div>
                                        Dias: {{ edicao.js_dias }}
                                    </div>
                                </div>
                            </div>

                            <div v-if="edicao.js_dias && edicao.js_dias.length" class="mb-3" title="Progresso: Realizado / Agendado">
                                <div class="progress">
                                    <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + percentual_realizado + '%'" v-if="percentual_realizado > 0"></div>
                                    <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + percentual_agendado + '%'" v-if="percentual_agendado > 0"></div>
                                </div>
                            </div>

                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                                        Protocolo
                                    </a>
                                </li>
                                <li class="nav-item" role="presentation" v-if="edicao.marcacoes">
                                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                                        Execução
                                    </a>
                                </li>
                                <li class="nav-item" role="presentation" v-if="false">
                                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Contact</a>
                                </li>
                            </ul>

                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                                    <template v-if="edicao.protocolos && edicao.protocolos.length">
                                        <ul class="list-group mt-3">
                                            <template v-for="(protocolo, ipx) in edicao.protocolos">
                                                <li class="list-group-item d-flex justify-content-between" :class="protocolo.fl_ativo ? 'list-group-item-info' : 'list-group-item-danger'" :key="ipx">
                                                    <div>
                                                        <div class="badge badge-danger" v-if="!protocolo.fl_ativo">
                                                            Removido
                                                        </div>
                                                        <div v-if="protocolo.receita.anamnese.atendimento_procedimento.atendimento">
                                                            <i class="fas fa-calendar-alt fa-fw mr-2"></i>
                                                            {{ $util.getFormatDate(protocolo.receita.anamnese.atendimento_procedimento.atendimento.dt_inicio) }}
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            #{{ protocolo.receita.anamnese.atendimento_procedimento.id_atendimento }}
                                                            <template v-if="protocolo.receita.anamnese.atendimento_procedimento.atendimento.unidade_operacao">
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ protocolo.receita.anamnese.atendimento_procedimento.atendimento.unidade_operacao.st_sigla }}
                                                            </template>
                                                        </div>
                                                        <div v-if="protocolo.receita.anamnese.atendimento_procedimento.atendimento.medico">
                                                            <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                                            {{ protocolo.receita.anamnese.atendimento_procedimento.atendimento.medico.search }}
                                                        </div>
                                                        <div v-if="protocolo.receita.procedimento">
                                                            <i class="fa fa-play fa-fw mr-2" aria-hidden="true"></i>
                                                            {{ protocolo.receita.procedimento.search }}
                                                        </div>
                                                        <div v-if="protocolo.receita.kit">
                                                            <i class="fa-solid fa-prescription-bottle-medical fa-fw mr-2"></i>
                                                            {{ protocolo.receita.kit.search }}
                                                        </div>
                                                    </div>
                                                    <div class="text-right d-flex flex-column justify-content-between">
                                                        <div>
                                                            <button type="button" class="btn btn-outline-danger" @click="remover_protocolo(protocolo)" v-if="protocolo.fl_ativo">
                                                                Remover
                                                            </button>
                                                        </div>

                                                        <div>
                                                            <a href="#" @click.prevent="protocolo.exibir = !protocolo.exibir">
                                                                <i class="fa fa-plus-square-o fa-fw" aria-hidden="true" v-if="!protocolo.exibir"></i>
                                                                <i class="fa fa-minus-square-o fa-fw" aria-hidden="true" v-else></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="list-group-item" :key="'OS' + ipx" v-if="protocolo.exibir">
                                                    <div class="alert alert-secondary small p-2" v-if="protocolo.receita && protocolo.receita.id_receita_editada">
                                                        Editada por {{  protocolo.receita.medico_edicao ? protocolo.receita.medico_edicao.search : '?' }}, em 
                                                        {{ $util.getFormatDate(protocolo.receita.dt_alteracao) }}
                                                        {{ protocolo.receita.dt_alteracao.slice(11,16) }}
                                                        ({{ protocolo.receita.id_receita_editada }})
                                                    </div>

                                                    <order-set-view :dados="[protocolo.receita]" type="receita" />

                                                    <table class="table table-sm mt-3 mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Prescrito</th>
                                                                <th>Qtde</th>
                                                                <th>Estoque</th>
                                                                <th>Apresentações</th>
                                                            </tr>
                                                        </thead>
                                                        <tr v-for="(rmi, ifx) in protocolo.receita.flat_items" :key="ifx">
                                                            <td v-if="rmi.item">
                                                                <template v-if="rmi.item">
                                                                    {{ rmi.item.search }}
                                                                    <span class="badge badge-secondary">
                                                                        #{{ rmi.id_medicamento }}
                                                                    </span>
                                                                </template>
                                                            </td>
                                                            <td>
                                                                {{ rmi.in_quantidade }}
                                                                {{ rmi.apresentacao ? rmi.apresentacao.search : '' }}
                                                            </td>
                                                            <td>
                                                                <template v-if="rmi.estoque_item">
                                                                    {{ rmi.estoque_item ? rmi.estoque_item.search : ''}}
                                                                    <span class="badge badge-secondary">
                                                                        #{{ rmi.estoque_item.id_estoque_item }}
                                                                    </span>
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <div>{{ rmi.quantidades_compra }}</div>
                                                                <div class="small text-muted" v-if="rmi.estoque_item && rmi.estoque_item.apresentacoes && rmi.estoque_item.apresentacoes.length">
                                                                    {{ rmi.estoque_item.apresentacoes.map(item => ( item.in_quantidade + '' ) + rmi.estoque_item.st_unidade_estoque)
                                                                        .join(', ') }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </li>
                                            </template>
                                        </ul>
                                    </template>

                                    <div class="mt-3" v-if="edicao.receitas && !edicao_selecionado">

                                        <az-empty-state 
                                            v-if="!edicao.id_infusao && !lista_receitas.length" 
                                            icon="fa-solid fa-file-medical"
                                            msg="Nenhum protocolo identificado." />

                                        <div v-else-if="lista_receitas.length">

                                            <ul class="list-group">
                                                <li class="list-group-item d-flex justify-content-between" v-for="(receita, irx) in lista_receitas" :key="irx">
                                                    <div>
                                                        <div v-if="!edicao.paciente && receita.anamnese.atendimento_procedimento.atendimento" class="lead">
                                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}, 
                                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.ch_sexo }},
                                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.idade }},
                                                            DN: {{ $util.getFormatDate(receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.dt_nascimento) }}
                                                        </div>
                                                        <div v-if="receita.anamnese.atendimento_procedimento.atendimento">
                                                            <i class="fas fa-calendar-alt fa-fw mr-2"></i>
                                                            {{ $util.getFormatDate(receita.anamnese.atendimento_procedimento.atendimento.dt_inicio) }}
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            #{{ receita.anamnese.atendimento_procedimento.id_atendimento }}
                                                            <template v-if="receita.anamnese.atendimento_procedimento.atendimento.unidade_operacao">
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ receita.anamnese.atendimento_procedimento.atendimento.unidade_operacao.st_sigla }}
                                                            </template>
                                                            <template v-if="receita.anamnese.atendimento_procedimento.atendimento.medico">
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ receita.anamnese.atendimento_procedimento.atendimento.medico.search }}
                                                            </template>
                                                        </div>
                                                        <div v-if="receita.procedimento">
                                                            <i class="fa-solid fa-prescription-bottle-medical fa-fw mr-2"></i>
                                                            {{ receita.procedimento.search }}
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ receita.kit.search }}
                                                        </div>
                                                        <div v-else-if="receita.kit">
                                                            <i class="fa-solid fa-prescription-bottle-medical fa-fw mr-2"></i>
                                                            {{ receita.kit.search }}
                                                        </div>
                                                        <div v-if="receita.protocolos && receita.protocolos.length">
                                                            <i class="fa-solid fa-syringe fa-fw text-success mr-2"></i>
                                                            {{ receita.protocolos.map(item => '#' + item.id_infusao).join(', ') }} 
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button type="button" class="btn btn-primary" :disabled="!!( receita.protocolos && receita.protocolos.length )" @click="selecionar_receita(receita)">
                                                            Selecionar
                                                        </button>
                                                    </div>
                                                </li>
                                            </ul>

                                        </div>

                                        <pre v-if="false">{{ edicao.receitas}}</pre>

                                    </div>        
                                </div>

                                <!-- Marcações / Execuções -->
                                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    
                                    <div class="mt-3" v-if="edicao.marcacoes && !edicao.marcacoes.length">
                                        <az-empty-state 
                                            msg="Nenhuma marcação realizada." 
                                            icon="fa fa-calendar-o" />
                                    </div>

                                    <div class="mt-3" v-else-if="edicao.marcacoes && edicao.marcacoes.length">
                                        <ul class="list-group">
                                            <li class="list-group-item d-flex justify-content-between" v-for="(marcacao, imx) in edicao.marcacoes" :key="imx">
                                                <div>
                                                    <div>
                                                        <i class="fa-solid fa-arrows-spin fa-fw mr-2"></i>
                                                        Ciclo: {{ marcacao.in_qt_ciclo }} <span v-if="edicao.protocolo && edicao.protocolo.receita">/ {{ edicao.protocolo.receita.in_ciclos }}</span>
                                                    </div>
                                                    <div>
                                                        <i class="fa fa-calendar-o fa-fw mr-2" aria-hidden="true"></i>
                                                        {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                                        {{ marcacao.dt_inicio.substr(11,5) }}
                                                    </div>
                                                    <div v-if="marcacao.procedimento">
                                                        <i class="fa fa-play fa-fw mr-2" aria-hidden="true"></i>
                                                        {{ marcacao.procedimento.st_procedimento }}
                                                    </div>
                                                    <div v-if="marcacao.unidade_operacao">
                                                        <i class="fa fa-building fa-fw mr-2" aria-hidden="true"></i>
                                                        {{ marcacao.unidade_operacao.st_nome }}
                                                        <span v-if="marcacao.local">
                                                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                            {{ marcacao.local.st_local }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="text-right">
                                                    <h4>
                                                        <span class="badge badge-secondary ml-2" v-if="marcacao.in_qt_dia">
                                                            D{{ marcacao.in_qt_dia }}
                                                        </span>
                                                    </h4>
                                                    <template v-if="marcacao.id_atendimento">
                                                        <div>
                                                            <i class="fa fa-check-circle text-success fa-2x" aria-hidden="true"></i>
                                                        </div>
                                                        <div>
                                                            <a href="#" @click.prevent="abrir_atendimento(marcacao)" class="card-link">
                                                                #{{ marcacao.id_atendimento }}
                                                            </a>
                                                        </div>
                                                    </template>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
                            </div>

                        </template>

                        <az-empty-state msg="Pesquisar paciente..." v-else icon="fa-solid fa-user" />

                        <br><br><br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()" v-if="edicao">{{ edicao.id_infusao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Marcação -->
        <div class="modal fade" id="marcacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Marcar
                            <span class="badge badge-secondary ml-2" v-if="edicao">
                                #{{ edicao.id_infusao }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="!edicao">
                        <az-empty-state />
                    </div>
                    <div class="modal-body" v-else>
                        <div class="alert alert-info">
                            <div class="lead">
                                {{ edicao.paciente.st_nome }}
                            </div>
                            <div v-if="edicao.st_titulo">
                                {{ edicao.st_titulo }}
                            </div>
                            <div v-if="edicao.procedimento" class="text-muted">
                                {{ edicao.procedimento.search }}
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="number"
                                    label="Ciclo"
                                    v-model="edicao.in_qt_ciclo">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="edicao.ciclos">
                                            <span class="input-group-text" id="basic-addon2">
                                                de {{ edicao.ciclos }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <template v-if="edicao.lista_dias && edicao.lista_dias.length">
                            <div class="row mt-3">
                                <div class="col col-12 d-flex flex-column">
                                    <az-input
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'S', search: 'Única' },
                                            { id: 'M', search: 'Dias' }
                                        ]"
                                        optionsData="id"
                                        v-model="edicao.tipo_marcacao" />
                                </div>
                            </div>
                        </template>

                        <div class="row" v-if="edicao.tipo_marcacao != 'M'">
                            <div class="col col-12">
                                <az-input
                                    v-if="edicao.js_dias"
                                    type="select"
                                    :optionsList="edicao.js_dias.map(item => { 
                                        return { 
                                            id: item,
                                            search: 'D' + item
                                        };
                                    })"
                                    optionsData="id"
                                    label="Dia"
                                    v-model="edicao.in_qt_dia" />

                                <az-input
                                    v-else
                                    type="number"
                                    label="Dia"
                                    v-model="edicao.in_qt_dia" />
                            </div>
                        </div>

                        <template v-if="edicao.lista_dias && edicao.lista_dias.length">
                            <table class="table table-sm table-hover mt-3">
                                <thead>
                                    <tr>
                                        <th width="5%" v-if="edicao.tipo_marcacao == 'M'"></th>
                                        <th>D</th>
                                        <th>Agenda</th>
                                        <th>Atendimento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in edicao.lista_dias" :key="idx"
                                        :class="( item.marcacao && item.marcacao.id_atendimento ) ? 'table-success' : ( item.marcacao ? 'table-primary' : '' )">
                                        <td v-if="edicao.tipo_marcacao == 'M'">
                                            <input type="checkbox" v-model="item.selecionado" :disabled="item.marcacao" />
                                        </td>
                                        <td>{{ item.search }}</td>
                                        <td>
                                            <template v-if="item.marcacao">
                                                {{ $util.getFormatDate(item.marcacao.dt_inicio) }}
                                                / {{ dia_da_semana($util.getFormatDate(item.marcacao.dt_inicio, 'd')) }}
                                            </template>

                                            <span class="text-muted small" v-else-if="item.prev_data">
                                                {{ $util.getFormatDate(item.prev_data) }}
                                                / {{ dia_da_semana($util.getFormatDate(item.prev_data, 'd')) }}
                                            </span>
                                        </td>
                                        <td>
                                            <template v-if="item.marcacao && item.marcacao.id_atendimento">
                                                #{{ item.marcacao.id_atendimento }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="marcar(edicao)" v-if="edicao">Marcar</button>
                    </div>
                </div>
            </div>
        </div>

        <pep-view-receitas ref="viewreceitas" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import OrderSetView from '../consultorio/OrderSetView.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import PepViewReceitas from '../consultorio/PepViewReceitas.vue';

export default {
    data() { 
        return { 
            dados: { 
                paciente: "",
                laudos: [],
            },
            canceltoken: null, 
            etiqueta_layouts: [],
            layout: this.$util.getCookie('etiqueta-layout-entrega'), 
            entrega: null, 
            entregar_para: null, 
            validate: false, 
            filtro: {
                tipo_data: "", 
                id_unidade_operacao: "", 
                id_procedimento: "", 
                inicio: "",
                fim: "",
                periodo: "do",
                search: "", 
                paciente: "", 
            },
            edicao: null, 
            page: 1, 
        };
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        CelulaDadosPaciente, 
        AzPeriodo, 
        AzSubmit,
        OrderSetView, 
        PrintExport,
        CabecalhoGenerico,
        PepViewReceitas, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados || !this.dados.data )
                return [];

            const reg = this.filtro.search ? this.$util.getregex(this.filtro.search) : null;

            return this.dados.data.filter(item => !this.filtro.search || ( reg && reg.test(JSON.stringify(item))) );
        },

        edicao_selecionado: function () { 
            if ( !this.edicao || !this.edicao.protocolos )
                return;

            return this.edicao.protocolos.find(item => item.fl_ativo);
        },

        lista_receitas: function () { 
            if ( !this.edicao || !this.edicao.receitas )
                return [];

            const reg = this.edicao.search ? this.$util.getregex(this.edicao.search) : null;

            return this.edicao.receitas.filter(item => !this.edicao.search || ( reg && reg.test(JSON.stringify(item))) );
        },

        percentual_realizado: function () { 
            if ( !this.edicao || !this.edicao.marcacoes ) 
                return 0;

            if ( !this.edicao || !this.edicao.js_dias || !this.edicao.js_dias.length ) 
                return 0;

            return Math.round((this.edicao.marcacoes.filter(item => item.id_atendimento).length / this.edicao.js_dias.length) * 100);
        },

        percentual_agendado: function () { 
            if ( !this.edicao || !this.edicao.marcacoes ) 
                return 0;

            if ( !this.edicao || !this.edicao.js_dias || !this.edicao.js_dias.length ) 
                return 0;

            return Math.round((this.edicao.marcacoes.filter(item => !item.id_atendimento).length / this.edicao.js_dias.length) * 100);
        }
    },

    methods: { 
        resumo_medicamentos (item) { 
            let atendimento = item;

            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'index',
                parms: { 
                    id_paciente: atendimento.id_paciente, 
                    receitas: true, 
                }
            })
            .then(res => { 
                this.$refs.viewreceitas.abrir(res, atendimento);
            });
        },

        dia_da_semana(dia) { 
            dia = parseInt(dia);

            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sáb';
                default: return dia;
            }
        },

        filtrar (texto) { 
            if ( this.filtro.search == '"' + texto + '"' ) { 
                this.filtro.search = "";
            } else { 
                this.filtro.search = '"' + texto + '"';
            }
        },

        remover_protocolo (protocolo) { 
            if ( !confirm('Confirma remover o protocolo?') )
                return;

            protocolo.fl_ativo = false;

            if ( !this.edicao.receitas ) { 

                this.edicao.receitas = [];
                this.$forceUpdate();

                this.$nextTick (() => { 

                    this.$util.load(this, { 
                        service: 'infusao',
                        func: 'receitas',
                        parms: { 
                            id_paciente: this.edicao.paciente.id_pessoa, 
                        },
                        loadTo: res => { 
                            this.edicao.receitas = res.lista; 
                        }
                    });

                });

            }
        },

        abrir_atendimento(item) { 
            $('.modal').modal('hide');

            this.$util.abrir_atendimento(this, item.id_atendimento);
        },

        editar (infusao) { 
            this.edicao = null;
            this.validate = false;

            $('#edicaoModal').modal('show');

            this.$util.load(this, { 
                service: 'infusoes',
                func: 'show',
                parms: { 
                    id: infusao.id_infusao,
                    edicao: true, 
                },
                loadTo: res => { 
                    res.receitas = [];
                    this.edicao = res;
                }
            });
        },

        agendar (infusao) { 
            this.edicao = null;

            $('#marcacaoModal').modal('show');

            this.$util.load(this, { 
                service: 'infusoes',
                func: 'show',
                parms: { 
                    id: infusao.id_infusao,
                    edicao: true, 
                },
                loadTo: res => { 
                    res.in_qt_ciclo = 1;
                    res.in_qt_dia = 1;

                    if ( res.marcacoes ) { 
                        const ultima = _.last(res.marcacoes);

                        if ( ultima && ultima.in_qt_ciclo ) { 
                            res.in_qt_ciclo = ultima.in_qt_ciclo;

                            let lista_dias = res.js_dias ? res.js_dias : res.dias;
                            let idx_last = -1; 

                            if ( lista_dias && lista_dias.length ) { 
                                idx_last = lista_dias.findIndex(item => item == ultima.in_qt_dia);
                            }

                            if ( lista_dias && lista_dias.length && idx_last >= 0 ) { 
                                
                                if ( idx_last >= 0 && idx_last < lista_dias.length ) { 
                                    res.in_qt_dia = lista_dias[idx_last + 1];
                                    res.in_qt_data = moment(ultima.dt_inicio)
                                        .add(res.in_qt_dia - ultima.in_qt_dia, "days")
                                        .format('YYYY-MM-DD');
                                }

                                res.tipo_marcacao = 'S';

                                res.lista_dias = lista_dias.map(item => { 
                                    let marcacao = res.marcacoes.find(marcacao => marcacao.in_qt_dia == item);

                                    return { 
                                        dia: item,
                                        search: 'D' + item, 
                                        marcacao: marcacao 
                                            ? { 
                                                id_marcacao: marcacao.id_marcacao,
                                                id_atendimento: marcacao.id_atendimento,
                                                dt_inicio: marcacao.dt_inicio,
                                                in_qt_dia: marcacao.in_qt_dia,
                                            }
                                            : null,
                                        prev_data: marcacao 
                                            ? ''
                                            : moment(ultima.dt_inicio)
                                                .add(item - ultima.in_qt_dia, "days")
                                                .format('YYYY-MM-DD'),
                                        selecionado: false, 
                                    };
                                });

                            } else if ( ultima.in_qt_dia && ( ultima.in_qt_dia == res.duracao ) ) { 

                                res.in_qt_ciclo = res.in_qt_ciclo + 1;
                                res.in_qt_dia = 1;

                            } else { 

                                res.in_qt_dia = ultima.in_qt_dia + 1;

                            }

                        }

                    }

                    this.edicao = res;
                }
            });
        },

        marcar (infusao) { 
            if ( !infusao.in_qt_ciclo || infusao.in_qt_ciclo < 0 ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Ciclo não informado.',
                    life: 3000
                });
                return;
            } else if ( infusao.ciclos && ( infusao.in_qt_ciclo > infusao.ciclos ) ) {
                /* 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Ciclo inválido: ' + infusao.in_qt_ciclo + ' (' + infusao.ciclos + ')',
                    life: 3000
                });
                return;
                */
            } 

            if ( infusao && infusao.tipo_marcacao == 'M' ) { 
                let proximo = infusao.lista_dias.findIndex(item => item.selecionado); 
                if ( proximo < 0 ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: 'Nenhum dia selecionado.',
                        life: 3000
                    });
                    return;
                } else { 
                    infusao.in_qt_dia = infusao.lista_dias[proximo].dia;
                    infusao.in_qt_data = infusao.lista_dias[proximo].prev_data;
                }
            } else { 
                if ( !infusao.in_qt_dia ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: 'Dia não informado.',
                        life: 3000
                    });
                    return;
                }
            }

            $('.modal').modal('hide');

            this.$nextTick(() => {
                this.$router.push({
                    name: "infusao",
                    params: { 
                        aba: 'marcacao', 
                        infusao: { 
                            id_infusao: infusao.id_infusao,
                            in_qt_ciclo: infusao.in_qt_ciclo,
                            in_qt_dia: infusao.in_qt_dia,
                            in_qt_data: infusao.in_qt_data, 
                            js_dias: infusao.js_dias,
                            id_procedimento: infusao.id_procedimento, 
                            lista: infusao.tipo_marcacao == 'M' 
                                ? infusao.lista_dias.filter(item => item.selecionado)
                                : [],  
                        }
                    }
                });
            });
        },

        log (infusao) { 
            this.$util.logAudit('infusao', infusao.id_infusao);
        },

        selecionar_receita (receita) { 
            this.edicao.st_titulo = receita.kit ? receita.kit.search : 'Protocolo de Infusão...';
            this.edicao.id_procedimento = receita.id_procedimento_protocolo;

            if ( !this.edicao.paciente && _.get(receita, 'anamnese.atendimento_procedimento.atendimento.paciente') ) { 
                this.edicao.paciente = receita.anamnese.atendimento_procedimento.atendimento.paciente;
            }
            
            this.edicao.protocolos.push({ 
                id_infusao_receita: null, 
                id_receita: receita.id_receita, 
                fl_ativo: true, 
                receita: receita 
            });
        },

        buscar_receitas () { 

            if ( this.edicao.paciente ) { 
                this.selecionarPaciente();
                return;
            }

            this.edicao.receitas = [];

            this.$nextTick (() => { 

                this.$util.load(this, { 
                    service: 'infusao',
                    func: 'paciente_receitas',
                    parms: { 
                        ...this.edicao.periodo, 
                        id_unidade_operacao: this.edicao.id_unidade_operacao,
                        id_medico: this.edicao.id_medico,
                    },
                    loadTo: res => { 
                        this.edicao.receitas = res.lista.data; 
                    }
                });

            });

        },

        incluir () { 
            this.validate = false;

            this.edicao = { 
                id_infusao: null, 
                id_paciente: null, 
                fl_ativo: true, 
                paciente: "", 
                protocolos: [], 
                receitas: [], 
                periodo: { 
                    periodo: "do", 
                }, 
                id_unidade_operacao: "",
                id_medico: "", 
                search: "", 
            };

            $('#edicaoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'infusoes',
                func: 'store', 
                dados: this.edicao, 
                modal: 'edicaoModal', 
                toast: true, 
                reload: true, 
            });
        },
        
        imprimir(laudo) { 
            if ( laudo.status_laudo && !laudo.status_laudo.fl_pronto ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: laudo.atendimento_procedimento.procedimento.search,
                    detail: "Laudo: " + laudo.status_laudo.search,
                    life: 3000
                });
                return;
            }

            this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true);
        },

        selecionarPaciente() { 
            if ( !this.edicao.paciente )
                return;

            this.edicao.receitas = [];

            this.$nextTick (() => { 

                this.$util.load(this, { 
                    service: 'infusao',
                    func: 'receitas',
                    parms: { 
                        id_paciente: this.edicao.paciente.id_pessoa, 
                    },
                    loadTo: res => { 
                        this.edicao.receitas = res.lista; 

                        console.log('res', res);
                    }
                });

            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'infusoes',
                func: 'index',
                parms: { 
                    planejamento: true, 
                    ...this.filtro, 
                    size: 100, 
                    page: this.page 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });

        }
    },

    mounted() { 

        this.$store.commit("setBreadcrumb", [
            { name: "Infusão", path: "/infusao/planejamento" },
            { name: "Planejamento", path: "/infusao/planejamento" },
        ]);

        this.load ();

    }   
}
</script>

<style scoped>
.modal-dialog-cheio {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
  min-height: 98% !important;
}
</style>